// components
import { ContractsComponent } from './contracts.component';
import { ContractsListComponent } from './list/contracts.list.component';
import { ContractsSingleIndexComponent } from './single-index/contracts.single.index.component';
import { ContractsAccrualsComponent } from './accruals/contracts.accruals.component';
import { ContractsPaymentsComponent } from './payments/contracts.payment.component';
import { ContractsDocumentationComponent } from './documentation/contracts.documentation.component';
import { ContractsObjectsComponent } from './objects/contracts.objects.component';
import { ContractsPrivilegesComponent } from './privileges/contracts.privileges.component';
import { ContractsPostponementComponent } from './postponement/contracts.postponement.component';
import { ActDialogContractsComponent } from './act-dialog/act.dialog.contracts.component';
import { CreateQuestComponent } from './create-quest/create.dialog.component';
import { SignatureModalComponent } from './signature/signature.modal.component';

export const CONTRACTS_COMPONENTS: any[] = [
  ContractsComponent,
  ContractsListComponent,
  ContractsSingleIndexComponent,
  ContractsAccrualsComponent,
  ContractsPaymentsComponent,
  ContractsDocumentationComponent,
  ContractsObjectsComponent,
  ContractsPrivilegesComponent,
  ContractsPostponementComponent,
  ActDialogContractsComponent,
  CreateQuestComponent,
  SignatureModalComponent,
];

// services
import { ContractModelService } from './contracts.model.service';
import { CreateSignatureDialogContractStateService } from './signature/signature.modal.state.service';


export const CONTRACTS_SERVICES: any[] = [
  ContractModelService,
  CreateSignatureDialogContractStateService
];



// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/index.ts